<template>
  <div id="app">
     <keep-alive>
       <router-view v-if="$route.meta.keepAlive" />
     </keep-alive>
     <router-view v-if="!$route.meta.keepAlive" />
   </div>
 </template>
 
 <script>
 export default {
   name: 'App',
   data() {
     return {
       currentLang: '',
       loginLoading: false,
     }
   },
   watch: {
     $route() {
     }
   },
   mounted() {
   },
 
   beforeDestroy() {
   },
 
   methods: {
   }
 }
 </script>
 
 <style>
 #app {
   height: 100%;
   margin: 0;
   padding: 0;
 }
 .mb-content {
   background: #fff8f0;
   min-height: 100vh;
 }
 
 .light {
   color: #000;
   background: #fff8f0;
 }
 </style>
 